module.exports = __webpack_public_path__ + "img/austria-stomach-cancer-female.68ea0677.png";